export default __webpack_public_path__ + "static/media/captcha.27cbada7.svg";